import React, { FunctionComponent } from 'react';
import { DropdownMenu, DropdownToggle, UncontrolledDropdown, Button, DropdownItem } from 'reactstrap';

import { faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { genId, useUserContext } from '@oceanjs/core';
import { FormattedMessage } from 'react-intl';



export interface IUserinfoControllerProps {
  id?: string;
}

interface IUserinfoLogoutButtonProps {
  /**
   * Some id
   */
  id: string;
  /**
   * The id for the formatted message
   */
  messageId: string;
  /**
   * Callback that is called once the user clicks the logout button
   */
  onLogout(): Promise<void> | void;
}



/**
 * The component UserinfoController
 */
export const WisaUserController: FunctionComponent<IUserinfoControllerProps> = ({ id: idProp }): JSX.Element => {
  const { user, login, logout } = useUserContext();
  const id = (idProp === undefined) ? genId('user','info') : idProp;

  // Check if a user is logged in
  if (user === null) {
    return (
      <Button id={genId(id, 'button-login')} onClick={handleLogin} color="primary" size="sm">
        <FontAwesomeIcon icon={faUser} className="mr-2" />
        <FormattedMessage id="login" />
      </Button>
    );
  }

  const username = user.username || 'N/A';
  const roles = user.roles.join(', ');
  const isPvpUser = user.gvGid != null;

  function handlePvpLogout(): void {
    window.location.href = '/';
  }

  async function handleLogin(): Promise<void> {
    return login(true);
  }

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle id={genId(id, 'dropdown-toggle')} nav caret>
        <span title={roles}>
          <FontAwesomeIcon icon={faUser} className="mr-2" />
          {username}
        </span>
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem id={isPvpUser ? genId(id, 'button-back-to-pvp'): genId(id, 'button-logout')} onClick={isPvpUser ? handlePvpLogout : logout}>
          <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
          <FormattedMessage id={isPvpUser ? 'backToPvpPortal' : 'logout'} />
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
